import { left } from '../../Either/dist/effect-Either.esm.js';
import { encode as encode$1, decode as decode$1 } from './Base64.esm.js';
import { DecodeException } from './Common.esm.js';

/** @internal */
const encode = data => encode$1(data).replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_");

/** @internal */
const decode = str => {
  const length = str.length;
  if (length % 4 === 1) {
    return left(DecodeException(str, `Length should be a multiple of 4, but is ${length}`));
  }
  if (!/^[-_A-Z0-9]*?={0,2}$/i.test(str)) {
    return left(DecodeException(str, "Invalid input"));
  }

  // Some variants allow or require omitting the padding '=' signs
  let sanitized = length % 4 === 2 ? `${str}==` : length % 4 === 3 ? `${str}=` : str;
  sanitized = sanitized.replace(/-/g, "+").replace(/_/g, "/");
  return decode$1(sanitized);
};

export { decode, encode };
